import axios from 'axios';
import { req } from './axiosFun';

// 订单列表
export const OrderList = (params) => { return req("get", "/api/Finance/orderList",params)};
// 对账信息
export const statement = (params) => {return req('get','/api/Finance/statement',params)};
// 对账详情
export const statementInfo = (params) => {return req('get','/api/Finance/statementInfo',params)};
// 同步订单信息
export const orderToHis = (params) => {return req('get','/api/Finance/orderToHis',params)};
// 退费列表
export const refundList = (params) => { return req("get", "/api/Finance/refundList",params)};
// 退费
export const wxRefund = (params) => { return req("post", "/api/Finance/wxRefund",params)};
// 对账
export const duizhang = (params) => { return req("get", "/api/Finance/duizhang",params)};
// 支付宝对账列表
export const zfbdzList = (params) => { return req("get", "/api/Alichat/zfbdzList",params)};
// 支付宝对账
export const zfbstatements = (params) => { return req("get", "/api/Alichat/statements",params)};
// 对账详情
export const zfbstatementInfo = (params) => {return req('get','/api/Alichat/statementInfo',params)};
// 支付宝订单列表
export const zfblist = (params) => {return req('get','/api/Alichat/zfbList',params)};
// 微信医保订单列表
export const ybOrderList = (params) => {return req('get','/api/Finance/ybOrderList',params)};



// WEBPACK FOOTER //
// ./src/api/payMG.js